<template>
  <span
    v-on:click.prevent="processOdd()"
    v-bind:class="[
      'bto-sb-event-odd',
      {
        'bto-sb-odd-lock':
          (outcome.outcome === '--' && outcome.id > 0) ||
          outcome.active === false ||
          match.isBetStop ||
          checkSuspended(),
        'bto-sb-event-odd-active': checkOddActive() && !match.isBetStop,
      },
      getOutcomeChangeClass,
      quickBetClasses,
    ]">
    <span
      v-if="getQuickBetNotification && getQuickBetNotification.betslip.status === 4"
      class="bto-sb-spinner-v1"></span>
    <i>{{ label }} {{ outcome.id === 0 ? '' : outcome.sbv }}</i>
    <i>{{ formatedOutcome || "--" }}</i>
  </span>
</template>

<script>
  import { formatOddDisplay } from '@bto-services/utils';
  import { toggleItem, toggleAlgoItem, isOddActive, placeQuickBet, getQuickbetPlacementMessage } from '@bto-services/betslip-core';
  import { mapMatchToBetslipItem, mapMatchToBetslipMatchItem, getQuickBetClass } from 'bto-models/betslip';
  import { UP_DOWN_CLASSES_WEB } from 'bto-models/match/live';
  import { showBetslipValidation } from '@bto-services/modal';

  export default {
    name: 'MatchOddUs',
    props: {
      match: {
        type: Object,
        default: () => {
        },
      },
      outcome: {
        type: Object,
        default: () => ({ upDownClass: 0 }),
      },
      odd: {
        type: Object,
        default: () => {
        },
      },
      label: {
        type: String,
        default: ''
      }
    },
    computed: {
      formatedOutcome() {
        return formatOddDisplay(this.outcome.originalDecimalOutcome, this.$root.oddFormat);
      },
      getQuickBetNotification() {
        return getQuickbetPlacementMessage({
          matchId: this.match.matchId,
          outcomeId: this.outcome.id,
          marketId: this.odd.marketId,
        });
      },
      quickBetClasses() {
        return getQuickBetClass(this.getQuickBetNotification);
      },
      getOutcomeChangeClass() {
        return UP_DOWN_CLASSES_WEB[this.outcome.upDownClass] || '';
      },
    },
    methods: {
      /**
       * Select or delete outcomes in match
       */
      processOdd() {
        if (this.outcome.originalDecimalOutcome === '--'
          || !this.outcome.id
          || this.outcome.active === false
          || this.match.isBetStop
          || this.emptyOdd
          || this.checkSuspended()) {
          return;
        }
        const outcome = { ...this.outcome };
        if (outcome.sbv && !`${outcome.name}`.includes(outcome.sbv)) {
          outcome.name = `${outcome.name} (${outcome.sbv})`;
        }
        const betslip_item = mapMatchToBetslipItem(
          this.match,
          outcome,
          this.odd,
          false,
          !this.match.isLiveMatch,
          false,
          this.match.isLiveMatch);
        const betslipMatchItem = mapMatchToBetslipMatchItem(this.match, false);
        const error = toggleAlgoItem(betslip_item, betslipMatchItem);
        showBetslipValidation(error);
        if (this.checkOddActive()) {
          placeQuickBet(betslip_item);
        }
      },
      /**
       * Check if odd is active
       */
      checkOddActive() {
        return isOddActive({
          matchId: this.match.matchId,
          outcomeId: this.outcome.id,
          marketId: this.odd.marketId,
        });
      },
      /**
       * Check "suspended" status
       */
      checkSuspended() {
        return this.match.suspended || this.outcome.suspended;
      },
    },
  };
</script>
